export default "__VITE_ASSET__C2Pkb5$G__"